// extracted by mini-css-extract-plugin
export default {"btnBack":"btnback_btnBack__nSy0I","circle":"btnback_circle__PM-o0"};